export default function R_WhileLoop() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_WhileLoop Component</h1>
      <p>This is the R_WhileLoop tutorial section.</p>
    </div>
  );
}
